/**
 * @generated SignedSource<<ea79884934402a3fdd5ec8d5e9bc775c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespContainer_displayInfo$data = {
  readonly pricing: {
    readonly showSale: boolean | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarButtons_displayInfo" | "PdpSharedPromoCode_displayInfo" | "PdpRespSidebarBlurbs_displayInfo">;
  readonly " $fragmentType": "PdpRespContainer_displayInfo";
};
export type PdpRespContainer_displayInfo$key = {
  readonly " $data"?: PdpRespContainer_displayInfo$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespContainer_displayInfo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespContainer_displayInfo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PriceInfoDisplay",
      "kind": "LinkedField",
      "name": "pricing",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showSale",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarButtons_displayInfo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedPromoCode_displayInfo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbs_displayInfo"
    }
  ],
  "type": "ItemDisplayInfo",
  "abstractKey": null
};

(node as any).hash = "97878c6d89108e4c4575f73ed189a60c";

export default node;
